module.exports = __webpack_public_path__ + "static/media/website-09.fd231f01.png";